import { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getKazoos, getPlannerKazoos } from '../../features/kazooEventSlice'
import VendorDashboard from '../../components/UserDashboard/Vendor'

/* TODO:: update data according to API response*/
const WeddingPlannerPage = () => {
	const dispatch = useDispatch()
	const user = useSelector((state) => state.auth.user)

	const plannerKazoos = useSelector((state) => state.kazooEvent.kazoos)

	const handleAccept = (kazooId) => {
		alert('Kazoo accepted')
	}

	const handleReject = (kazooId) => {
		alert('Kazoo rejected')
	}

	useEffect(() => {
		dispatch(getPlannerKazoos())
	}, [dispatch])

	const formattedData = useMemo(
		() =>
			plannerKazoos?.length
				? plannerKazoos.map((kazoo) => {
						return {
							...kazoo,
                            id: kazoo._id,
                            status: kazoo.status,
					        date: kazoo?.date?.slice(0, 10),
							accept: () => handleAccept(kazoo._id),
							reject: () => handleReject(kazoo._id),
							viewDetails: () =>
								window.location.replace(
									`/wedding/wedding-dashboard/${kazoo._id}`
								),
						}
					})
				: [],
		[plannerKazoos]
	)

	return <VendorDashboard data={formattedData} />
}

export default WeddingPlannerPage
